import { useForm } from 'react-hook-form'
import leaveRequestCreateSchema, { LeaveRequestCreateSchema } from '../../../../database/validations/LeaveRequestCreate'
import { zodResolver } from '@hookform/resolvers/zod'
import { LeaveRequestSource } from '../../../../database/enums/LeaveRequestSource.enum'
import { AccountTeam } from '../../../../database/enums/AccountTeam.enum'
import { LeaveTime } from '../../../../database/enums/LeaveTime.enum'
import { LeaveType } from '../../../../database/enums/LeaveType.enum'
import LeaveRequestService from '../../../../services/leave-request'
import { useEffect, useState } from 'react'
import { FetchStatus } from '../../../../types/fetch-status.types'
import constants from '../../../../constants'
import { ApprovalStatus } from '../../../../database/enums/ApprovalStatus.enum'
import authStore from '../../../../store/authStore'

const formEmptyValue: LeaveRequestCreateSchema = {
  source: LeaveRequestSource.JAPAN,
  approvalStatus: ApprovalStatus.UNRESPONDED,
  name: '',
  email: '',
  accountTeam: AccountTeam.PRODUCT_AND_MARKETING,
  position: '',
  startDate: new Date(),
  endDate: new Date(),
  leaveTime: LeaveTime.FULL_DAY,
  leaveType: LeaveType.ANNUAL_LEAVE,
  otherLeaveType: '',
  supportingDocument: null,
  reason: '',
}

export default function useLeaveRequestJapanTeamPageViewModel() {
  const user = authStore(state => state.user)
  const [addDataStatus, setAddDataStatus] = useState<FetchStatus>(constants.fetchStatus.default)

  const formHook = useForm<LeaveRequestCreateSchema>({
    defaultValues: formEmptyValue,
    mode: 'onChange',
    resolver: zodResolver(leaveRequestCreateSchema),
  })

  useEffect(() => {
    if (!!user) {
      formHook.reset({
        ...formEmptyValue,
        name: user.displayName ?? '',
        email: user.email ?? '',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  async function onSubmit(data: LeaveRequestCreateSchema) {
    setAddDataStatus({ ...constants.fetchStatus.default, isLoading: true })
    await LeaveRequestService.add(data)
      .then(() => setAddDataStatus({ ...constants.fetchStatus.default, isSuccess: true }))
      .catch(e => {
        console.log(e)
        setAddDataStatus({ ...constants.fetchStatus.default, isError: true })
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
  }

  function resetPage() {
    formHook.reset({ ...formEmptyValue, name: user?.displayName ?? '', email: user?.email ?? '' })
    setAddDataStatus(constants.fetchStatus.default)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return { formHook, onSubmit, addDataStatus, resetPage }
}
